// Copyright (c) 2022 by Move Closer

import { ModuleSize } from '@movecloser/page-builder/lib/contracts'

import { ModuleBase, ModuleFactory } from '../../contexts'

import { AvailableModuleDriver } from '../allowed'
import { abstractModuleFactory, getDefaultModuleAlignment } from '../abstract/form'

import { ProductsSetModule, ProductsSetModuleContent } from './ProductsSet.contracts'
import { ProductsSetCategoryPriceGroup } from './ProductsSet.config'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const productsSetContentFactory = (): ProductsSetModuleContent => ({
  thumbnail: null,
  description: '',
  title: '',
  products: [],
  categoryPrices: {
    [ProductsSetCategoryPriceGroup.A]: {
      regular: '',
      promotion: ''
    },
    [ProductsSetCategoryPriceGroup.B]: {
      regular: '',
      promotion: ''
    },
    [ProductsSetCategoryPriceGroup.C]: {
      regular: '',
      promotion: ''
    },
    [ProductsSetCategoryPriceGroup.D]: {
      regular: '',
      promotion: ''
    },
    [ProductsSetCategoryPriceGroup.E]: {
      regular: '',
      promotion: ''
    },
    [ProductsSetCategoryPriceGroup.F]: {
      regular: '',
      promotion: ''
    },
    [ProductsSetCategoryPriceGroup.G]: {
      regular: '',
      promotion: ''
    }
  }
})

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const productsSetFactory: ModuleFactory<ProductsSetModule> = {
  ...abstractModuleFactory,
  createInitialSize (): ModuleSize {
    return {
      colSpan: 12,
      isResizable: true,
      rowSpan: 4
    }
  },
  createModule (): ModuleBase<ProductsSetModule> {
    return {
      alignment: getDefaultModuleAlignment(),
      content: productsSetContentFactory(),
      driver: AvailableModuleDriver.ProductsSet
    }
  }
}
